import { PropTableValues } from "../../../../src/components";
import { Textarea } from '@primer/react-brand';
import * as React from 'react';
export default {
  PropTableValues,
  Textarea,
  React
};